import { useEffect, useState } from "react";
import { BusyLabel } from "@/components/loading";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

export default function Login() {
  useEffect(() => {
    const reason = sessionStorage.getItem("hittcg_logout_reason");
    if (!reason) return;
    sessionStorage.removeItem("hittcg_logout_reason");
    toast.info(reason === "Sesión cerrada por cambio de contraseña"
      ? "Tu sesión se cerró porque cambiaste la contraseña. Vuelve a iniciar sesión."
      : "Tu sesión se cerró por seguridad. Vuelve a iniciar sesión.", { duration: 8000 });
  }, []);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [needsTotp, setNeedsTotp] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await login(email, password, totp || undefined);
      if (r.requireTotp) {
        setNeedsTotp(true);
        toast.info("Ingresa tu código 2FA");
        setLoading(false);
        return;
      }
      toast.success("Bienvenido");
      if (r.role === "admin" || r.role === "moderator") nav("/admin"); else nav("/");
    } catch (err) {
      const detail = err.response?.data?.detail || "Error al iniciar sesión";
      const suspended = /suspend|banned/i.test(String(detail));
      if (suspended) {
        toast.error(detail, {
          duration: 8000,
          action: {
            label: "Recuperar cuenta",
            onClick: () => nav("/recuperar-cuenta"),
          },
        });
      } else {
        toast.error(detail);
      }
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="flex justify-center mb-8"><Logo /></div>
      <div className="bg-[#111] border border-[#262626] rounded-md p-8">
        <h1 className="font-display text-3xl mb-6">INGRESAR</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-neutral-400 mb-2 block text-xs uppercase tracking-wider">Email</Label>
            <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-[#171717] border-[#262626] text-white" />
          </div>
          <div>
            <Label className="text-neutral-400 mb-2 block text-xs uppercase tracking-wider">Contraseña</Label>
            <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-[#171717] border-[#262626] text-white" />
          </div>
          {needsTotp && (
            <div>
              <Label className="text-neutral-400 mb-2 block text-xs uppercase tracking-wider">Código 2FA</Label>
              <Input data-testid="login-totp" value={totp} onChange={(e) => setTotp(e.target.value)} placeholder="6 dígitos" className="bg-[#171717] border-[#262626] text-white" />
            </div>
          )}
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-[#EF4444] hover:bg-[#DC2626]">
            <BusyLabel busy={loading} text="Entrando…">Ingresar</BusyLabel>
          </Button>
          <div className="flex justify-between items-center gap-2 flex-wrap">
            <Link to="/recuperar-cuenta" data-testid="link-claim-account" className="text-xs text-neutral-400 hover:text-[#EF4444]">
              ¿Perdiste acceso al correo?
            </Link>
            <Link to="/forgot-password" data-testid="link-forgot-password" className="text-xs text-neutral-400 hover:text-[#EF4444]">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
        </form>
        <div className="mt-6 pt-6 border-t border-[#262626] text-sm text-neutral-400 text-center">
          ¿No tienes cuenta? <Link to="/register" data-testid="link-register" className="text-[#EF4444] hover:underline">Regístrate</Link>
        </div>
      </div>
    </div>
  );
}
